"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemCustomRubricSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const custom_rurbic_serializer_1 = require("./custom-rurbic.serializer");
class ItemCustomRubricSerializer extends dp_http_client_lib_1.PageableSerializer {
    constructor(customRubricSerializer = new custom_rurbic_serializer_1.CustomRubricSerializer()) {
        super();
        this.customRubricSerializer = customRubricSerializer;
    }
    serializeOne(data) {
        return {
            id: data.id,
            externalItemId: data.externalItemId,
            externalQuestionId: data.externalQuestionId,
            customRubric: this.customRubricSerializer.serializeOne(data.customRubric),
        };
    }
    serializeFindByAttemptId(data) {
        return {
            attemptId: data.attemptId,
            itemCustomRubrics: this.serialize({ data: data.itemCustomRubrics }).data,
        };
    }
}
exports.ItemCustomRubricSerializer = ItemCustomRubricSerializer;
//# sourceMappingURL=item-custom-rubric.serializer.js.map